// src/constants/columns/staffColumns.js

import { Link } from "react-router-dom";
import { FaEdit } from "react-icons/fa";

export const staffColumns = [
  { field: "name", headerName: "Name", flex: 1, minWidth: 150 },
  { field: "email", headerName: "Email", flex: 1, minWidth: 200 },
  { field: "phone", headerName: "Phone", flex: 1, minWidth: 150 },
  { 
    field: "role", 
    headerName: "Role", 
    flex: 1, 
    minWidth: 120,
    renderCell: (params) => params.value.charAt(0).toUpperCase() + params.value.slice(1),
  },
  { 
    field: "isActive", 
    headerName: "Status", 
    flex: 1, 
    minWidth: 120,
    renderCell: (params) => params.value ? "Active" : "Inactive",
  },
  { 
    field: "permissions", 
    headerName: "Permissions", 
    flex: 1.5, 
    minWidth: 250,
    renderCell: (params) => {
      const perms = params.value;
      const activePerms = [];
      if (perms.canCredit) activePerms.push("Credit");
      if (perms.canDebit) activePerms.push("Debit");
      if (perms.canCreateUser) activePerms.push("Create User");
      if (perms.canViewReports) activePerms.push("View Reports");
      return activePerms.join(", ") || "-";
    },
  },
  {
    field: "actions",
    headerName: "Actions",
    flex: 0.5,
    minWidth: 100,
    sortable: false,
    renderCell: (params) => (
      <Link
        to={`/admin-dashboard/staffs/edit/${params.row._id}`}
        style={{ textDecoration: "none" }}
      >
        <FaEdit size={18} style={{ color: "#1976d2", cursor: "pointer" }} />
      </Link>
    ),
  },
];
